import axios from 'axios'
 
const Api = axios.create({
                         baseURL: process.env.VUE_APP_BASEAPI,
                         headers: {
                             'Access-Control-Allow-Origin':'*',
                            }
});

Api.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('access_token')
  
    if (token) {
      config.headers['Authorization'] = 'Bearer '+token;
    }
    
    return config
  },

  (error) => {
    return Promise.reject(error)
  }
)

export default Api; 